module.exports = __webpack_public_path__ + "static/media/cusd1.1dd8b226.jpg";